export const PREVIEW_IMAGE_WIDTH = 360
export const PREVIEW_IMAGE_HEIGHT = 360
export const DETAIL_IMAGE_WIDTH = 762
export const DETAIL_IMAGE_HEIGHT = 762
